import { mainColors } from 'src/assets/colors';
import styled from '@emotion/styled';

interface WrapperPropsType {
    isDisabled : boolean;
    marginBottom?: string;
}
export const Wrapper = styled('label', { label: 'Wrapper' })<WrapperPropsType>`
    display: flex;
    align-items: center;
    opacity: ${({ isDisabled }): number => (isDisabled ? 0.4 : 1)};
    pointer-events: ${({ isDisabled }): string => (isDisabled ? 'none' : 'auto')};
    margin-bottom: ${({ marginBottom }): string => (marginBottom ?? '0')};
`;

export const SwitcherWrapper = styled('div', { label: 'SwitcherWrapper' })`
    position: relative;
    display: inline-block;
    width: 32px;
    height: 16px;
    flex: 0 0 auto;
    margin: 0 8px 4px 0;
`;

export const Input = styled('input', { label: 'Input' })`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + span {
        background-color: ${mainColors.main.secondary};
    }

    &:focus + span {
        box-shadow: 0 0 1px ${mainColors.main.secondary};
    }

    &:checked + span::before {
        transform: translateX(16px);
    }
`;

export const Slider = styled('span', { label: 'Slider' })`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${mainColors.grays.gray200};
    transition: 0.4s;
    border-radius: 8px;
    box-sizing: border-box;
    border: 2px solid ${mainColors.main.secondary};

    &::before {
        position: absolute;
        content: '';
        height: 16px;
        width: 16px;
        box-sizing: border-box;
        border: 2px solid ${mainColors.main.secondary};
        left: -2px;
        bottom: -2px;
        background-color: ${mainColors.default.light};
        transition: 0.4s;
        border-radius: 50%;
    }
`;
